import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-70fc606e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trips-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Trips", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Trips", -1))
const _hoisted_5 = {
  key: 0,
  class: "state"
}
const _hoisted_6 = {
  key: 1,
  class: "state error"
}
const _hoisted_7 = {
  key: 2,
  class: "state"
}
const _hoisted_8 = {
  key: 3,
  class: "table-wrap"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Start"),
    /*#__PURE__*/_createElementVNode("th", null, "End"),
    /*#__PURE__*/_createElementVNode("th", null, "Students")
  ])
], -1))

import { onMounted, ref } from "vue";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { TripRecord } from "../types";

interface Trip extends TripRecord {
  students: Array<{ id: number }>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripsView',
  setup(__props) {

const trips = ref<Trip[]>([]);
const loading = ref(true);
const error = ref("");

const fetchTrips = async () => {
  loading.value = true;
  error.value = "";
  try {
    const response = await fetch(`${API_URL}/trips`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to load trips");
    }
    trips.value = await response.json();
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to load trips");
  } finally {
    loading.value = false;
  }
};

onMounted(fetchTrips);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading trips..."))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : (trips.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "No trips found."))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("table", null, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trips.value, (trip) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: trip.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(trip.name), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.date), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.startTime), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.endTime), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.students.length), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
  ]))
}
}

})